import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { AssetsBookingsState } from "./state";
import * as AD2 from "lib/at-data/AsyncData2";

export const initialState: AssetsBookingsState = {
  bookings: AD2.pending(O.none),
};
